import { render, staticRenderFns } from "./_TotalReceivedAndNotRow.vue?vue&type=template&id=51056c50"
import script from "./_TotalReceivedAndNotRow.vue?vue&type=script&lang=js"
export * from "./_TotalReceivedAndNotRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports